<template>
	<main>
		<crumbs :crumbs="crumbs"></crumbs>
		<div class="wrap" v-show="category_list.length > 0">
			<div class="title-box">
				<div class="title">近距离与专家交流</div>
				<div class="min-title">留下您的联系方式，即可预约专家时间，与专家近距离的沟通，解答您的疑惑。</div>
			</div>
			<div class="category">
				<div class="swiper-container" id="swiper-category">
					<div class="swiper-wrapper">
						<div class="swiper-slide" v-for="(item,index) in category_list" @click="chooseCategory(item,index)">
							<div class="item" :style="{backgroundImage:'url('+util.autoImage((category.id == item.id ? item.bg : item.bg2))+')'}" :class="[category.id == item.id ? 'active' : '']" >
								<div class="cen">
									<div class="middle">
										<div class="icon"><img :src="util.autoImage(item.icon)" alt=""></div>
										<div class="icon icon-a"><img :src="util.autoImage(item.icon2)" alt=""></div>
										<div class="tit">{{item.title}}</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="category-box">
				<div class="box" v-for="(item,index) in category_list" @click="chooseCategory(item,index)" :key="index" v-if="index < 2" :class="[item.id == category.id ? 'active' : '']">
					<div class="tit">{{item.title}}</div>
				</div>
			</div>
			<div class="list">
				<div class="item" v-for="(item,index) in speaker_list">
					<div class=" avatar">
						<div class="box">
							<div class="img" :style="{backgroundImage:'url('+util.autoImage(item.avatar)+')'}"></div>
						</div>
					</div>
					<div class="info">
						<div class="user">
							<div class="username">{{item.username}}</div>
							<div class="job"><span v-html="item.job"></span> <span style="color:#376f84" @click="showDesc(item)">了解更多专家信息</span></div>
						</div>
						<div class="button" @click="showSpeaker(item)"><div class="left icon"></div><div class="left tit">预约专家交流</div></div>
					</div>
				</div>
			</div>
			<div class="tips"><i>* </i>以上专家列表不分先后</div>
		</div>
		<speaker-message v-if="show_speaker.id" :speaker="show_speaker" @hideSpeaker="show_speaker = {}"></speaker-message>
	</main>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import 'swiper/dist/css/swiper.css'
import Crumbs from "../../components/m/Crumbs";
import Loading from "../../components/m/Loading";
import SpeakerMessage from "@/components/m/SpeakerMessage";
import { Dialog } from 'vant';
export default {
	name: 'honored',
	data() {
		return {
			query:"",
			category_list:[],
			category:{},
			speaker_list:[],
			data_loading:true,

			show_speaker:{}
		}
	},
	components:{
		Crumbs,Loading,swiper,swiperSlide,SpeakerMessage
	},
	computed:{
		crumbs() {
			return {title:"专家面对面",min_title:"TALK TO EXPERT"}
		},
	},
	methods: {
		showDesc(item){
			Dialog({
				title:"专家介绍",
				message: item.desc,
				messageAlign:"left",
				confirmButtonColor:"#376f84"
			});
		},
		showSpeaker(item){
			gio('track', 'DTF2021_talkclick',{
				DTF2021_teachername:item.username,
			});

			this.show_speaker = item;
		},
		swiperInit(){
			this.swiper = new Swiper('#swiper-category',{
				slidesPerView:this.category_list.length > 3 ? 3.5 : 3,
				spaceBetween: 15,
				slidesOffsetAfter:2,
				watchOverflow:true,
				slideToClickedSlide:true,
				observer:true,
				observeSlideChildren:true,
			})
		},
		chooseCategory(item,index){
			this.category = item;
			this.getSpeakerList();
		},
		getSpeakerList(){
			this.http.request({
				api:"speaker/getSpeakerList",
				data:{
					speaker_category_id:this.category.id
				},
				success:(res)=>{
					this.speaker_list = res.list;
					this.data_loading = false;
					this.$nextTick(()=>{
						this.util.showBottom(true);
					})
				}
			})
		},
		getCategoryList(){
			this.http.request({
				api:"speaker/getCategoryList",
				success:(res)=>{
					this.category_list = res.category;
					this.category = res.category[0];
					this.getSpeakerList();
					this.$nextTick(()=>{
						this.swiperInit();
					})
				}
			})
		}
	},
	mounted() {
		this.query = this.$route.query;
		this.getCategoryList();
	}
}
</script>

<style lang="scss" type="text/scss" scoped>
.wrap{background: url("~@/assets/image/2021/17_m.png") no-repeat bottom center;background-size:100% auto;padding:.4rem;overflow: hidden;
	.title-box{padding-left: 30px;background: url("~@/assets/image/2021/10.png") no-repeat left top;background-size: 100px;text-align: left;
		.title{font-size:.48rem;line-height:.64rem;color:#376f84;}
		.min-title{font-size:.26rem;color:#444;margin-top:.18rem;line-height: .36rem;}
	}
	.category{margin-top: .4rem;display:none;
		.swiper-container{padding: .1rem ;
			.item{height:1.2rem;box-shadow: 0 0 .1rem .02rem rgba(0,0,0,.1); position: relative;cursor: pointer;text-align: center;transition: all .3s ease;background-repeat: no-repeat;background-position: center center;background-size: 100% 100%;
				.cen{display: inline-block;
					.middle{text-align: center;transition: all .3s ease;height:1.2rem;
						.icon{width:.58rem;height:.41rem;margin: 0 auto;
							img{display: block; width: 100%;height:100%;object-fit: contain;}
						}
						.icon-a{display: none;margin: 0 auto;}
						.tit{color:#333;font-size:.24rem;line-height:.31rem;margin-top: .1rem;}
					}
				}
			}
			.item.active{transition: all .3s ease;background: url("~@/assets/image/b44.jpg") no-repeat center center;background-size: 100% 100%;
				.cen{
					.middle{
						.icon{display: none;}
						.icon-a{display: block;}
						.tit{color:#fff;}
					}
				}
			}
			.item:nth-last-child(1){margin-right: 0;}
		}
	}
	.category-box{margin:.4rem auto 0;display: flex;
		.box{flex: 1;height:.7rem;background: url("~@/assets/image/b3.png") no-repeat center center;background-size: 100% 100%;text-align: center;line-height: .7rem;color:#333;cursor: pointer;font-size: .26rem;font-weight: bold;}
		.box.active{background: url("~@/assets/image/b1.png") no-repeat center center;background-size: 100% 100%;color:#fff;}
		.box:nth-child(2){margin-right: 0;background-image: url("~@/assets/image/b2.png");background-size: 100% 100%;color:#333;}
		.box:nth-child(2).active{background-image: url("~@/assets/image/b4.png");background-size: 100% 100%;color:#fff;}
	}
	.list{margin-top: .4rem;
		.item{padding:.2rem;margin-bottom:.3rem;box-shadow:0 0 .1rem .02rem rgba(0,0,0,.1);background:#fff;background-size: auto 100%;display: flex;
			.avatar{width:2.16rem;height:2.16rem;position: relative;
				.box{background: url("~@/assets/image/2021/36.png") no-repeat center center;background-size: 100% 100%;position:absolute;top:0;left:0;width: 100%;height:100%;z-index: 2;overflow: hidden;border-top-right-radius: .6rem;border-bottom-left-radius:.6rem;
					.img{width: 80%;height:90%;position: absolute;top:10%;left:10%; background-repeat: no-repeat;background-position:center center;background-size: cover;}
				}
			}
			.avatar::before{content: "";display: block;position: absolute;top:-.1rem;right:-.1rem;width: .95rem;height:.95rem;background: url("~@/assets/image/2021/10.png") no-repeat center center;background-size: 100% 100%;}
			.avatar::after{content: "";display: block;position: absolute;bottom:-.1rem;left:-.1rem;width: .95rem;height:.95rem;background: url("~@/assets/image/2021/10.png") no-repeat center center;background-size: 100% 100%;}
			.info{margin-left:.3rem;flex: 1;
				.user{padding-top: .1rem;
					.username{font-size:.24rem;line-height:.31rem;font-weight: bold;padding-left:.2rem;background: url("~@/assets/image/2021/24.png") no-repeat left center;background-size: .12rem;}
					.job{font-size:.22rem;line-height:.33rem;color:#808080;margin-top:.14rem;}
				}
				.button{margin-top:.23rem;width:2.14rem;height:.5rem;display: flex;cursor: pointer;
					.icon{width: .5rem;background: #138EEA url('~@/assets/image/2021/23.png') no-repeat center center;background-size:.27rem;}
					.tit{flex: 1;background: #376f84;text-align: center;line-height: .5rem;font-size: .22rem; color:#fff;transition: all .3s ease;}
				}
			}
		}
	}
	.tips { font-size:.26rem; padding-bottom:.3rem;text-align: left;color:#999;
		i{color:red;}
	}
}
</style>

